import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";

export default function AcceptInvite() {
  const { token } = useParams();
  const { acceptInvite } = useAuth();
  const nav = useNavigate();
  const [invite, setInvite] = useState(null);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/auth/invite/${token}`).then((r) => setInvite(r.data)).catch((e) => setError(formatApiError(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) return setError("Password must be at least 6 characters");
    if (password !== confirm) return setError("Passwords don't match");
    setBusy(true);
    const r = await acceptInvite(token, password);
    setBusy(false);
    if (r.ok) nav("/dashboard"); else setError(r.error);
  };

  if (error && !invite) return (
    <div className="min-h-screen flex items-center justify-center p-8">
      <div className="border-2 border-[#FF2A00] bg-white p-8 max-w-md">
        <div className="label-caps text-[#FF2A00] mb-2">Invite invalid</div>
        <p>{error}</p>
      </div>
    </div>
  );

  if (!invite) return <div className="p-8 text-neutral-500 font-mono-tight text-sm">Loading…</div>;

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center p-8">
      <form onSubmit={submit} className="w-full max-w-sm bg-white border-2 border-black p-8" data-testid="accept-invite-form">
        <div className="label-caps mb-1">Set your password</div>
        <h1 className="font-display text-3xl font-bold">Welcome, {invite.name.split(" ")[0]}.</h1>
        <p className="text-sm text-neutral-600 mt-1">Setting up: <b>{invite.email}</b></p>
        <label className="label-caps block mb-1 mt-6">New Password</label>
        <Input data-testid="invite-password" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-none border-black mb-3" />
        <label className="label-caps block mb-1">Confirm Password</label>
        <Input data-testid="invite-confirm" required type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="rounded-none border-black" />
        {error && <div className="border border-[#FF2A00] text-[#FF2A00] p-2 text-sm mt-3">{error}</div>}
        <button data-testid="invite-submit" type="submit" disabled={busy} className="mt-5 w-full bg-black text-white py-3 hard-shadow-hover disabled:opacity-50">
          {busy ? "Setting up…" : "Activate account →"}
        </button>
      </form>
    </div>
  );
}
